<span class="bc-selector tooltip-container" style="margin-right: 5px;">
  <div dropdown class="btn-group flex" #dropdown [autoClose]="false" (onShown)="onShown()">
  <span class="icon-span">
    <i #dropdownToggle dropdownToggle class="btn btn-bc dropdown-toggle {{icon}}"   style="font-size: 1.6em;"></i>
  </span>
  <a (click)="nameClickSelect()" class="hover-title" style="font-size: 12px">{{ title | translate:locale.language}}</a>
  <ul *dropdownMenu class="dropdown-menu" role="menu">
    <input class="form-control"
           #dropdownFilter
           [(ngModel)]="selected"
           [autofocus]="true"
           [typeahead]="list | async"
           [typeaheadOptionsLimit]="20"
           [typeaheadOptionsInScrollableView]="15"
           [typeaheadMinLength]="0"
           [typeaheadScrollable]="true"
           [typeaheadOptionField]="filterVue"
           (typeaheadOnSelect)="typeaheadOnSelect($event)"
           (typeaheadNoResults)="noResult($event)"
           placeholder="{{ filterPlaceholder | translate:locale.language}}">
  </ul>
  </div>
</span>
